import React from 'react';
import { useStore } from '../../../../store';
import { BALANCE_HEADERS } from '../../constants';
import BucketBalance from '../../../../generic-components/BucketBalance';
import { validateFeatureFlag } from '../../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../../constants/general';

const EmergencyBucketBalance = () => {
  const { BASIC_USER, PRO_USER } = BALANCE_HEADERS;
  const summary = useStore(state => state.summary);
  const { getPrimaryAccount } = useStore(state => state);
  const isAddButtonDisabled = () => getPrimaryAccount().balance <= 0;
  const isWithdrawButtonDisabled = () => {
    if (summary && summary.emergencyBucketResponse && typeof summary.emergencyBucketResponse.balance === 'number') {
      return summary.emergencyBucketResponse.balance <= 0;
    }
    return true;
  };

  const getEmergencyBucket = () => {
    if (summary && summary.emergencyBucketResponse && typeof summary.emergencyBucketResponse.balance === 'number' && summary.emergencyBucketResponse.balance >= 0) {
      if (`${summary.emergencyBucketResponse.balance}`.indexOf('.') !== -1 && (`${summary.emergencyBucketResponse.balance}`.length - `${summary.emergencyBucketResponse.balance}`.indexOf('.') === 2)) {
        return `$${summary.emergencyBucketResponse.balance}0`;
      }
      return `$${summary.emergencyBucketResponse.balance}${Number.isInteger(summary.emergencyBucketResponse.balance) ? '.00' : ''}`;
    }
    return '$0.00';
  };

  return (
    <BucketBalance
      addButtonDisabled={isAddButtonDisabled()}
      withdrawButtonDisabled={isWithdrawButtonDisabled()}
      addButtonPath='/emergency-bucket-add-money'
      withdrawButtonPath='/emergency-bucket-withdraw-money'
      bucketBalance={getEmergencyBucket()}
      bucketName={validateFeatureFlag(FEATURE_FLAG.EMERGENCY_SAVING_ACCOUNT) ? PRO_USER : BASIC_USER}
    />
  );
};

export default EmergencyBucketBalance;
